import { MicromedidoresService } from './../../../../services/micromedidores.service';
import { MatDialogRef } from '@angular/material';
import { MapaService } from './../../../../services/mapa.service';
import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';

@Component({
	selector: 'kt-micromedidor-ultima-transmision',
	templateUrl: './micromedidor-ultima-transmision.component.html',
	styleUrls: ['./micromedidor-ultima-transmision.component.scss']
})
export class MicromedidorUltimaTransmisionComponent implements OnInit {
	public micromedidoresDataSource: any;
	public showFilterRow: boolean;
	public showHeaderFilter: boolean;
	public fecha: any;
	public hora: any;
	public datosReporte = [];
	 isDisabled: boolean = true;

	constructor(private mapaService: MapaService,
		public dialogRef: MatDialogRef<MicromedidorUltimaTransmisionComponent>,
		private datePipe: DatePipe,
		private micromedidoresService: MicromedidoresService) {
		this.showFilterRow = true;
		this.showHeaderFilter = true
	}

	ngOnInit() {
		this.obtenerMicromedidores();
	}

	obtenerMicromedidores() {
		let temNumSeries = [];
		let newResponse = []
		this.micromedidoresService.obtenerMicromedidoresUltimaTransmision().subscribe(
			(response) => {
				response.map(function (micrommedidor) {
					if (micrommedidor.tamper == null || micrommedidor.tamper == '') {
						micrommedidor.tamper = 'Sin datos'
					}

					if (micrommedidor.observacion == null || micrommedidor.observacion == '') {
						micrommedidor.observacion = 'Sin datos'
					}

					if (micrommedidor.contador == null || micrommedidor.contador == '') {
						micrommedidor.contador = 'Sin datos'
					}
				});

				response.forEach(
					micromedidor => {
						let numeroSerie = micromedidor.numeroSerie;
						if (!(temNumSeries.includes(numeroSerie))) {
							temNumSeries.push(numeroSerie);
							newResponse.push(micromedidor);
						}
					}
				);
				this.micromedidoresDataSource = newResponse;

				this.micromedidoresDataSource.forEach(micromedidor => {
					this.datosReporte.push({
						'Número de Serie': micromedidor.numeroSerie,
						'Última Transmisión': this.datePipe.transform(micromedidor.fechaHora, 'dd/MM/yyyy HH:mm a'),
						'Contador L': micromedidor.contador,
						'Observación': micromedidor.observacion
					});
				});
				if(this.datosReporte.length > 0){
					this.isDisabled = false;
				}
			}
		)
	}

	reportePosiciones() { }

	ubicarPuntoHistorico(data) {
		this.mapaService.verMedidor(data);
		this.dialogRef.close();

	}


	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}

}
